/** @file Import dialog session: read, choose layers, upload and place; a failed upload resumes. */
import { createStore } from 'zustand/vanilla';
import { editDraft } from './editDraft';
import type { ImportCore, ImportSession, ImportSessionDeps, ImportStep } from './importTypes';
import { openSources } from './openSources';
import { startImport } from './startImport';

/** The store starts `closed`; every action outside its step is ignored; close() drops late answers; dispose() is close for an unmounting host. */
export function createImportSession(deps: ImportSessionDeps): ImportSession {
  const store = createStore<ImportStep>()(() => ({ kind: 'closed' }));
  const core: ImportCore = { store, deps, ticket: { n: 0 } };
  const close = (): void => {
    const step = store.getState();
    if (step.kind === 'uploading') return;
    if ('draft' in step && step.draft?.source.kind === 'psd') step.draft.source.session.close();
    core.ticket.n += 1;
    store.setState({ kind: 'closed' }, true);
  };
  /** Unmount cleanup: an upload cannot be stopped, so its answer is dropped and startImport closes the PSD when it settles. */
  const dispose = (): void => {
    if (store.getState().kind === 'uploading') core.ticket.n += 1;
    else close();
  };
  return { store, ...openSources(core), ...editDraft(core), start: startImport(core), close, dispose };
}
